import {
    LUCID_NETWORK_CUSTOM_NAME,
    LUCID_NETWORK_EMULATOR_NAME_MOCK_NO_EXISTE_EN_LUCID,
    LUCID_NETWORK_MAINNET_NAME,
    LUCID_NETWORK_PREPROD_NAME,
    LUCID_NETWORK_PREVIEW_NAME,
} from '@/src/lib/MayzSmartDB';

export const enum ROUTES {
    HOME = '/',
    FAQS = '/faqs',
    DISCLAIMER = '/disclaimer',
    ADMIN = '/admin',
    PORTFOLIO = '/portfolio',
    UNDERCONSTRUCTION = '/under-construction',
}

export type WebsiteUrls = {
    governanceUrl: string;
    dappUrl: string;
};

export const getWebSitesUrls = (): WebsiteUrls => {
    let res: WebsiteUrls;
    switch (process.env.NEXT_PUBLIC_CARDANO_NET) {
        case LUCID_NETWORK_MAINNET_NAME:
            res = {
                governanceUrl: process.env.NEXT_PUBLIC_WEBSITE_GOVERNANCE_MAINNET_URL!,
                dappUrl: process.env.NEXT_PUBLIC_WEBSITE_DAPP_MAINNET_URL!,
            };
            break;
        case LUCID_NETWORK_PREVIEW_NAME:
        case LUCID_NETWORK_PREPROD_NAME:
        case LUCID_NETWORK_CUSTOM_NAME:
            res = {
                governanceUrl: process.env.NEXT_PUBLIC_WEBSITE_GOVERNANCE_TESTNET_URL!,
                dappUrl: process.env.NEXT_PUBLIC_WEBSITE_DAPP_TESTNET_URL!,
            };
            break;
        case LUCID_NETWORK_EMULATOR_NAME_MOCK_NO_EXISTE_EN_LUCID:
            res = {
                governanceUrl: process.env.NEXT_PUBLIC_WEBSITE_GOVERNANCE_EMULATOR_URL!,
                dappUrl: process.env.NEXT_PUBLIC_WEBSITE_DAPP_EMULATOR_URL!,
            };
            break;
        default:
            throw `env NEXT_PUBLIC_CARDANO_NET not set correctly`;
    }
    if (res.governanceUrl === undefined || res.dappUrl === undefined) {
        throw `env WEBSITE_GOVERNANCE_URL or WEBSITE_DAPP_URL not set correctly`;
    }
    return res;
};
